import { Component } from '@angular/core';

@Component({
  selector: 'description',
  template: '<p class="description"><ng-content></ng-content></p>',
  styleUrls: ['./description.component.scss'],
})
export class DescriptionComponent {}
